import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { UmbrellaOrganizationsProductPlansSelect as UmbrellaOrganizationsProductPlansSelectComponent } from '../../../UmbrellaOrganizationsProductPlansSelect'

export const SubscriptionSection = styled.section`
  margin-top: ${Spacing.S32};
`

export const ProductPlansSection = styled.div`
  margin-top: ${Spacing.S8};
`

export const UmbrellaOrganizationsProductPlansSelect = styled(UmbrellaOrganizationsProductPlansSelectComponent)`
  margin-top: ${Spacing.S2};
`
